import {DefaultLinkModel} from "@projectstorm/react-diagrams";

export class NodeLinkModel extends DefaultLinkModel {
    constructor() {
        super({
			type: 'default',
			width:  3,
			color: 'gray',
			selectedColor:  'rgb(0,192,255)',
			curvyness: 0,
		});

    }
}
